import React, { Component } from 'react';
import { Line } from 'react-chartjs-2';

export class Graph extends Component {

    constructor(props) {
        super(props);
        this.state = {
            def: this.props.def,
            mfd: this.props.mfd
        }
    }

    render() {
        const state = {
            labels: ['Januar', 'Februar', 'Marts', 'April', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'December'],
            datasets: [
                {
                    label: 'DEF',
                    fill: false,
                    lineTension: 0.5,
                    backgroundColor: 'rgba(75,192,192,1)',
                    borderColor: 'rgba(0,0,0,1)',
                    borderWidth: 1,
                    data: this.state.def
                },
                {
                    label: 'MFD',
                    fill: false,
                    lineTension: 0.5,
                    backgrounColor: 'rgba(75,192,192,1)',
                    borderColor: 'rgba(0,0,0,1)',
                    borderWidth: 1,
                    data: this.state.mfd
                }
            ]
        }

        return (
            <div>
                <Line data={state} options={{ title: { display: true, text: 'Fuldtidsledige', fontSize: 10 }, legend: { display: true, position: 'right' } }} />
            </div>
        );
    }
}